import { ChangeEvent } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import Search from '@mui/icons-material/Search';

type OwnerState = {
  expanded: boolean;
  hasValue: boolean;
};

const StyledTextField = styled(TextField)<{ ownerState: OwnerState }>(
  ({ theme, ownerState }) => ({
    width: ownerState.expanded ? 300 : 'var(--trigger-width)',
    opacity: ownerState.expanded ? 1 : 0,
    transition: theme.transitions.create(['width', 'opacity']),
    backgroundColor: ownerState.hasValue
      ? 'transparent'
      : theme.palette.background.default,
    '& .MuiOutlinedInput-root': {
      backgroundColor: ownerState.hasValue
        ? 'transparent'
        : theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.text.secondary,
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.text.secondary,
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
      },
    },
    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
    borderRadius: 0.75,
  })
);

interface SharedSearchBarProps
  extends Omit<TextFieldProps, 'value' | 'onChange'> {
  expanded?: boolean;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const SharedSearchBar = ({
  expanded = true,
  value,
  onChange,
  placeholder = 'Search',
  sx,
  ...props
}: SharedSearchBarProps) => {
  const hasValue = Boolean(value);
  return (
    <StyledTextField
      {...props}
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      sx={sx}
      ownerState={{
        expanded,
        hasValue,
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
